import React, { FC, useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import {
  toAbsoluteUrl,
  headerSortingClasses,
  sortCaret,
} from "../../../../helpers";
import { Card, CardBody, CardHeader } from "../../../../partials/controls";
import {
  getEDMHeaderFooter,
  updateEDMHeaderFooter,
} from "../../../../service/settings/edmHeaderFooter";
import { getAllCompanies } from "../../../../service/companyService";
import { Link } from "react-router-dom";
import { SizePerPage } from "../../../../common/table/filters/SizePerPage";
import { Table } from "../../../../common/table";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import Loader from "../../../../common/loader";
import { FilterQuery } from "../../../../common/table/filters/FilterQuery";
import { StatusFilter } from "../../../../common/table/filters/StatusFilter";
import { useHistory } from "react-router";
import { sortServerString } from "../../../../common/table/sorter";
import { PaginationLinks } from "../../../../common/pagination/PaginationLinks";
import { PaginationToolbar } from "../../../../common/pagination/PaginationToolbar";
import { Modal } from "react-bootstrap";
import moment from "moment";

const EDMHeaderFooter: FC = () => {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [query, setQuery] = useState<string>("");
  const [totalData, setTotalData] = useState<number>(1);
  const [entities, setEntities] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [type, setType] = useState<string>("ACTIVE");
  const [companyList, setCompanyList] = useState<any>([]);
  const [company, setCompany] = useState("");
  const [sortingType, setSortingType] = useState<any>("");

  const StatusColumnFormatter = (status: any) => {
    if (status) {
      return (
        <span
          className={`label label-lg label-light-${
            status === "ACTIVE" ? `success` : `danger`
          } label-inline font-weight-normal font-size-11`}
        >
          {status === "ACTIVE" ? "Active" : "Inactive"}
        </span>
      );
    }
  };
  const openEditKey = (id) => {
    history.push(`/setting/edm-header-footer/update/${id}`);
  };
  const ActionEdit = (cellContent: any, row: any, rowIndex: any) => {
    return (
      <>
        <div
          title="Edit Gateway"
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditKey(row._id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </div>

        {row?.status === "ACTIVE" ? (
          <div
            title="Delete Gateway"
            className="btn btn-icon btn-light btn-sm mx-3"
            onClick={() => {
              setSelectedId(row?._id);
              setShow(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/trash.svg")}
              />
            </span>
          </div>
        ) : null}
      </>
    );
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      onSort: (field: string, order: string) =>
        sortServerString(field, order, setSortingType),
    },
    {
      dataField: "companyId",
      text: "Company ID",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      onSort: (field: string, order: string) =>
        sortServerString(field, order, setSortingType),
    },
    {
      dataField: "createdAt",
      text: "Created At",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      onSort: (field: string, order: string) =>
        sortServerString(field, order, setSortingType),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: StatusColumnFormatter,
    },
    {
      dataField: "action",
      text: "Action",
      formatter: ActionEdit,
    },
  ];

  const getCompanyList = () => {
    getAllCompanies()
      .then((res: any) => {
        let optionVal = res.data.data.map((x: any) => {
          return {
            label: x?.name,
            value: x?.name,
          };
        });
        optionVal = [{ label: "All", value: "" }, ...optionVal];
        setCompanyList(optionVal);
      })
      .catch((err) => {});
  };

  const getKeyList = (page = 1, sizePerPage = 10, showLoading = true) => {
    const isStatus =
      type !== "" && company !== ""
        ? `&filter={"status":"${type}","companyId":"${company}"}`
        : type === "" && company !== ""
        ? `&filter={"companyId":"${company}"}`
        : type !== "" && company === ""
        ? `&filter={"status":"${type}"}`
        : "";

    const isSortColumn =
      sortingType !== "" ? `&${sortingType}` : `&sortOrder=asc&field=keyName`;

    if (showLoading) {
      setLoading(true);
    }
    getEDMHeaderFooter(page, sizePerPage, query, isStatus, isSortColumn)
      .then((res: any) => {
        setLoading(false);

        if (res?.data?.docs.length === 0 && page !== 1) {
          getKeyList(page - 1);
          setPage(page - 1);
          return;
        }

        const listData = res?.data?.docs.map((data: any, index: any) => {
          return {
            _id: data._id,
            index: ++index + (page - 1) * sizePerPage,
            name: data.name,
            companyId: data.companyId,
            status: data?.status,
            createdAt: moment(data?.createdAt).format("YYYY-MM-DD"),
          };
        });

        setEntities(listData);
        setTotalData(res?.data?.totalDocs);
      })
      .catch((err) => {
        setLoading(false);
        history.push("/auth/login");
      });
  };

  const customTotal = (from: any, to: any, size: any) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {totalData === 0 ? 0 : (page - 1) * sizePerPage + 1} to {to}{" "}
      of {totalData}
    </span>
  );

  const paginationOptions = {
    custom: true,
    totalSize: totalData,
    hideSizePerPage: true,
    showTotal: true,
    page,
    sizePerPage,
    paginationTotalRenderer: customTotal,
  };

  const onTableChange = async (type: any, props: any, paginationProps: any) => {
    if (type !== "sort") {
      setSizePerPage(props.sizePerPage);
      if (props.sizePerPage > paginationProps.totalSize) {
        setPage(1);
        getKeyList(1, props.sizePerPage);
        setPage(1);
      } else {
        setPage(props.page);
        getKeyList(props.page, props.sizePerPage);
      }
    }
  };

  const handleSizePerPage = (
    { page, onSizePerPageChange }: any,
    newSizePerPage: any
  ) => {
    onSizePerPageChange(newSizePerPage, page);
  };

  const getSelectRow = {
    mode: "radio",
    clickToSelect: true,
    hideSelectColumn: true,
  };

  useEffect(() => {
    getKeyList(1, 10, false);
    getCompanyList();
    // eslint-disable-next-line
  }, [query, type, company, sortingType]);

  const onSwitchAction = (id: any, status: any) => {
    const body = {
      status: status, //=== "Active" ? "Inactive" : "Active",
    };
    updateEDMHeaderFooter(id, body)
      .then((res: any) => {
        if (res?.status === 200) {
          getKeyList(page);
          setShow(false);
          setSelectedId(null);
          setPage(page);
          setSizePerPage(10);
        }
      })
      .catch((err) => {});
  };

  return (
    <Card>
      <Modal
        show={show}
        onHide={() => {
          setSelectedId(null);
          setShow(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>Confirm</Modal.Header>
        <Modal.Body>Please confirm delete this EDM Header & Footer.</Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => {
                setShow(false);
                setSelectedId(null);
              }}
              className="btn btn-secondary btn-elevate"
            >
              Close
            </button>
            <> </>
            <button
              type="button"
              className="btn btn-primary btn-elevate"
              onClick={() => {
                onSwitchAction(selectedId, "INACTIVE");
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {loading && <Loader />}
      <CardHeader title="EDM Header & Footer">
        <div className="d-flex align-items-center">
          <div
            title="Refresh Data"
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            role="button"
            onClick={() => {
              getKeyList();
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/reload.svg")} />
            </span>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => (
            <>
              <div className="d-flex flex-column flex-md-row flex-sm-column">
                <div className="d-flex flex-column flex-md-row flex-sm-column mb-10">
                  <StatusFilter
                    status={type}
                    setStatus={(e: any) => {
                      setType(e);
                      setPage(1);
                    }}
                    options={[
                      { label: "All", value: "" },
                      { label: "Active", value: "ACTIVE" },
                      { label: "Inactive", value: "INACTIVE" },
                    ]}
                  />

                  <StatusFilter
                    label="company"
                    status={company}
                    setStatus={(e) => {
                      setCompany(e);
                      setPage(1);
                    }}
                    options={companyList}
                  />

                  <FilterQuery
                    query={query}
                    setQuery={(e) => {
                      setQuery(e);
                      setPage(1);
                    }}
                  />
                </div>

                <div className="mt-4">
                  <Link
                    className="btn btn-primary"
                    to="/setting/edm-header-footer/add"
                  >
                    New Header & Footer
                  </Link>
                </div>
              </div>
              <Table
                getSelectRow={getSelectRow}
                paginationProps={paginationProps}
                paginationOptions={paginationOptions}
                paginationTableProps={paginationTableProps}
                data={entities}
                columns={columns}
                remote
                onTableChange={(type: any, props: any) =>
                  onTableChange(type, props, paginationProps)
                }
              />
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <PaginationLinks paginationProps={paginationProps} />
                </div>
                <div className="d-flex">
                  <SizePerPage
                    paginationProps={paginationProps}
                    handleSizePerPage={handleSizePerPage}
                    entities={entities}
                  />
                  <PaginationToolbar paginationProps={paginationProps} />
                </div>
              </div>
            </>
          )}
        </PaginationProvider>
      </CardBody>
    </Card>
  );
};

export default EDMHeaderFooter;
